import React from 'react';

interface SearchHistoryDropdownProps {
  activeTab: 'recent' | 'saved';
  recentSearches: string[];
  savedSearches: string[];
  onTabChange: (tab: 'recent' | 'saved') => void;
  onSearchSelect: (search: string) => void;
}

const SearchHistoryDropdown: React.FC<SearchHistoryDropdownProps> = ({
  activeTab,
  recentSearches,
  savedSearches,
  onTabChange,
  onSearchSelect,
}) => {
  const searches = activeTab === 'recent' ? recentSearches : savedSearches;

  return (
    <div className="search-history-dropdown">
      <div className="search-history-tabs">
        <button
          className={`tab-btn ${activeTab === 'recent' ? 'active' : ''}`}
          data-tab="recent"
          onClick={() => onTabChange('recent')}
        >
          Recent searches
        </button>
        <button
          className={`tab-btn ${activeTab === 'saved' ? 'active' : ''}`}
          data-tab="saved"
          onClick={() => onTabChange('saved')}
        >
          Saved searches
        </button>
      </div>
      <div className="search-history-list">
        {searches.map((search, index) => (
          <div
            key={`${activeTab}-${index}`}
            className="search-history-item"
            role="button"
            tabIndex={0}
            onClick={() => onSearchSelect(search)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSearchSelect(search);
              }
            }}
          >
            {search}
          </div>
        ))}
        {searches.length === 0 && (
          <div className="search-history-empty">
            {activeTab === 'recent'
              ? 'You have no recent searches.'
              : 'You have no saved searches.'}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHistoryDropdown;
